export { default } from './AccordionDetails';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/AccordionDetails/index.js
// module id = 805
// module chunks = 2